export const getEmployees = state => state.employees.list;
export const listByTaxYear = state => state.employees.listByTaxYear;
export const getSelectedEmployee = state => state.employees.selected;
export const getEmployeeFilterData = state => state.employees.filterData;
